import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DetachedCommentAnchor = _resolveComponent("DetachedCommentAnchor");
    const _component_EditorCell = _resolveComponent("EditorCell");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass([
            'row-container',
            'side-by-side',
            _ctx.blockWidthClass,
            _ctx.isTextNodeFirst ? 'column-reverse' : 'column',
        ])
    }, [
        _createElementVNode("div", {
            class: _normalizeClass(['flex-container', _ctx.blockWidthClass])
        }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commentsWithoutCell, (comment) => {
                return (_openBlock(), _createBlock(_component_DetachedCommentAnchor, {
                    id: comment.id,
                    key: comment.id
                }, null, 8, ["id"]));
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cells, (cell, index) => {
                return (_openBlock(), _createBlock(_component_EditorCell, {
                    key: cell.id,
                    "cell-id": cell.id,
                    "cell-width": cell.width,
                    nodes: cell.nodes,
                    theme: _ctx.theme,
                    "merge-values": _ctx.mergeValues,
                    "row-type": _ctx.RowType.SideBySide,
                    "parent-first-child": _ctx.isParentFirstChild(index),
                    "parent-last-child": _ctx.isParentLastChild(index),
                    "block-width-class": _ctx.blockWidthClass,
                    "page-width": _ctx.pageWidth,
                    "is-block-toggled": _ctx.isBlockToggled,
                    comments: _ctx.filterCommentsByCell(_ctx.comments, cell.id),
                    "selected-comment-id": _ctx.selectedCommentId,
                    "show-contextual-comments": _ctx.showContextualComments,
                    "create-contextual-comment-button-state": _ctx.createContextualCommentButtonState,
                    onCreateComment: ($event) => (_ctx.$emit('create-comment', Object.assign(Object.assign({}, $event), { cellId: cell.id }))),
                    onSelectComment: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('select-comment', $event))),
                    onNodeClick: ($event) => (_ctx.$emit('node-click', Object.assign(Object.assign({}, $event), { cellId: cell.id }))),
                    onObserveNodeVisibility: ($event) => (_ctx.$emit('observe-node-visibility', Object.assign(Object.assign({}, $event), { cellId: cell.id }))),
                    onFetchNewImage: ($event) => (_ctx.$emit('fetch-new-image', Object.assign(Object.assign({}, $event), { targetCellId: cell.id })))
                }, null, 8, ["cell-id", "cell-width", "nodes", "theme", "merge-values", "row-type", "parent-first-child", "parent-last-child", "block-width-class", "page-width", "is-block-toggled", "comments", "selected-comment-id", "show-contextual-comments", "create-contextual-comment-button-state", "onCreateComment", "onNodeClick", "onObserveNodeVisibility", "onFetchNewImage"]));
            }), 128))
        ], 2)
    ], 2));
}
